import React, { Component } from 'react';
import TextField from "material-ui/TextField"
import { withStyles } from 'material-ui/styles';
import Button from 'material-ui/Button';
import { CircularProgress } from 'material-ui/Progress';

import green from 'material-ui/colors/green';

import Dialog, { DialogTitle, DialogContentText,DialogContent,DialogActions } from 'material-ui/Dialog';


import { ajaxPost } from '../ajax';
import Typography from 'material-ui/Typography/Typography';

const styles = theme => ({
      fabProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -15,
        marginLeft: -15,
          },
      wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
        display:'inline-flex',
      },
    
});

class DeleteDeviceDialog extends Dialog {
        state =
        {
            busy : false,
            error:"",
            serialNumber:"",
        }

        handleClose = ()=>
        {
            this.props.onClose(false);
        }

        handleChange = (evt) =>
        {
            this.setState({serialNumber:evt.target.value});
        }

        handleDelete = () =>
        {
            if( this.props.device.SerialNumber != this.state.serialNumber )
            {
                this.setState({error:"The entered serial number must be the same with the one selected for deletion"});
                return;
            }
            this.setState({error:""});
            this.setState({busy:true});
            
            ajaxPost({
                url: '/DeviceAPI/Delete',
                data: this.props.device.DeviceID,
                onError: ()=>{},
                onSuccess: data => {
                    this.props.onClose(true);
                },
                finally: ()=>
                {
                }
            }
            )        
            
        }

        render = ()=>
        {
            const {classes} = this.props;

            return (
                <div>
            <Dialog
            open={this.props.open}
            aria-labelledby="form-dialog-title"
            >
            <DialogTitle id="form-dialog-title">Delete Device</DialogTitle>
            <DialogContent>
            <DialogContentText>
            Please input the serial number of the selected device to verify the delete action
            </DialogContentText>
            <TextField
            autoFocus
            margin="dense"
            id="name"
            label="SERIAL NUMBER"
            fullWidth
            disabled={this.state.busy}
            value={this.state.serialNumber}
            onChange={this.handleChange.bind(this)}
            />
            <Typography variant="body1" color="error">
            {this.state.error}
            </Typography>
            </DialogContent>
            <DialogActions>
            <Button onClick={this.handleClose} color="primary" disabled={this.state.busy}>
            Cancel
            </Button>
            <div className={classes.wrapper}>
                <Button disabled={this.state.busy} color="primary" className={classes.button} onClick={this.handleDelete}>
                Delete
                </Button>
                {this.state.busy && <CircularProgress size={30} className={classes.fabProgress} />}
            </div>
            </DialogActions>
            </Dialog>            
            </div>
            )
        }
}


export default withStyles(styles)(DeleteDeviceDialog);


// WEBPACK FOOTER //
// ./src/admin/DeleteDeviceDialog.js